// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dna-editor{padding:1rem}.dna-editor .dna-input-group{color:#1E2B4E;margin-bottom:2rem}.dna-editor .dna-input-group>label{font-weight:600;margin-bottom:0.5rem}.dna-editor .dna-input-group input,.dna-editor .dna-input-group select{margin-bottom:1rem;border:1px solid #D7DEEA;font-weight:500;border-radius:5px;padding:6px;width:100%}\n", ""]);
// Exports
module.exports = exports;
